/**
 * 位置情報データを表すデータ型
 */
export interface GeoInformation {
    //フライトID
    flightId: string,
    //時間
    sendTime: string
    //ドローンID
    droneId: string,
    //緯度
    latitude: number,
    //経度
    longitude: number,
    //高度
    altitude: number,
    /*
    　方位角（機体からの直接の情報連携により利用可能な場合）
    　アプリから送信された位置情報の場合及び古い位置情報の場合利用不可
    */
    heading?: number,
    /*
    　速度（機体からの直接の情報連携により利用可能な場合）
    　アプリから送信された位置情報の場合及び古い位置情報の場合利用不可
    */
    speed?: number,
    //位置情報の送信方法
    transferMethod?: TransferMethod
}

/**
 * MAPスタイル
 */
export const MapStyle = {
    /**
     * 地形
     */
    neutral: "neutral",
    /**
     * 衛星写真
     */
    satellite: "satellite"
} as const;
/**
 * ポートタイプ
 */
export type MapStyle = typeof MapStyle[keyof typeof MapStyle];

/**
 * 位置情報の送信方法
 */
export const TransferMethod = {
    /**
     * 地上波（LTE・直接波等遅延の少ない通信方法を使用して送信されたもの）
     */
    groundWave: "groundWave",
    /**
     * 衛星波
     */
    satellite: "satellite"
} as const;
/**
 * ポートタイプ
 */
export type TransferMethod = typeof TransferMethod[keyof typeof TransferMethod];